import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrap_header" }
const _hoisted_2 = { style: {"font-size":"12px","color":"brown","text-align":"left"} }
const _hoisted_3 = {
  key: 0,
  id: "fotter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString($setup.currentTime.toLocaleTimeString('en-GB')) + " " + _toDisplayString($setup.currentTime.toLocaleDateString('en-GB')), 1)
    ]),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "wrap_header" }, [
            _createElementVNode("p", { class: "coppyi" }, "© Copyright 2025 - Trung tâm Y tế Hòa Vang - Designed by voontv@gmail.com")
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}